import React from 'react'
import {useEffect} from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
const Hero = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div>
      <div className='content home'>
        <div>
          <h3>Hi, I am</h3>
          <h2 className="bigname">Sibashis Som</h2>
          <h3>and I am a coder.</h3>
        </div>
        <div>
          <img src="/photo.jpg" alt="My Portrait" className="my-img"></img>
          </div>
      </div>
        <div className="content" id="About">
            <h2>About Me</h2>
            <p>I am a second-year undergraduate student at IIT Kharagpur enrolled in its CSE course.<br></br> I am a passionate web developer who likes working with new technologies to make fun, innovative and dynamic websites and aims to be a great software engineer one day.<br></br> I love competitive programming and in my free time, I indulge in watching football and singing classical music.</p>
        </div>
        <div className="content" id="Projects">
            <h2>Projects</h2>
            <div className="container">
              <div className="card" data-aos="fade-up" data-aos-delay="400">
              <img src="https://img.freepik.com/premium-vector/editable-text-effect-quiz-time-3d-cartoon-template-style-premium-vector_480443-1656.jpg?semt=ais_hybrid" alt="quiz app" className="card-img"></img>
                <div>
                  BlitzQuiz: A dynamic quiz app which offers an engaging experience while also boosting your quiz knowledge.
                  <br></br>
                  <div className="distance">
                    <a href="https://blitzquizapp.netlify.app" target="_blank" rel="noreferrer">Visit</a>
                    <a href="https://github.com/sibashis12/charredmetal" target="_blank" rel="noreferrer">Code</a>
                  </div>
                </div>
              </div>
              <div className="card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://img.freepik.com/free-vector/orange-blue-background-list_23-2149020601.jpg?semt=ais_hybrid" alt="to-do list app" className="card-img"></img>
                <div>
                  <br></br>
                  Questify: A to-do list React app that lists tasks according to importance and urgency and boosts productivity.
                  <br></br>
                  <div className="distance">
                    <a href="https://questifylist.netlify.app" target="_blank" rel="noreferrer">Visit</a>
                    <a href="https://github.com/sibashis12/crackedlotus" target="_blank" rel="noreferrer">Code</a>
                  </div>
                </div>
              </div>
              <div className="card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://img.freepik.com/free-vector/hand-with-wallet-money-icon-isolated_18591-82231.jpg?semt=ais_hybrid" alt="expense-tracker app" className="card-img"></img>
                <div>
                  <br></br>
                  Pluto Finance: An expense tracker React app that lists your transactions in different categories, helps you edit, visualize and delete them.
                  <br></br>
                  <div className="distance">
                    <a href="https://pluto-finance.netlify.app/" target="_blank" rel="noreferrer">Visit</a>
                    <a href="https://github.com/sibashis12/crazedchariot" target="_blank" rel="noreferrer">Code</a>
                  </div>
                </div>
              </div>
              <div className="card" data-aos="fade-up" data-aos-delay="400">
              <img src="https://img.freepik.com/free-vector/ocean-sea-waves-with-ripples_1017-30742.jpg?ga=GA1.1.477001833.1724087360&semt=ais_hybrid" alt="iot-based project" className="card-img"></img>
                <div>
                Water-quality monitoring system which is Iot-based and uses 4 sensors to measure pH, turbidity, conductivity and temperature to measure overall water quality.
                <br></br>
                  <div className="distance">
                    <a href="https://youtu.be/KsxayHozgzk?si=pSu3V7JLIwAiw6tP" target="_blank" rel="noreferrer">Visit</a>
                    <a href="https://drive.google.com/drive/folders/1vHs0pZTNF3ERueagNSTkRc3jqi4B9Gxy?usp=drive_link" target="_blank" rel="noreferrer">Project Material</a>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div className="skills" id="Skills">
            <h2>Skills</h2>
            <div className="container-small">
                <div className="card-small" data-aos="fade-up" data-aos-delay="400"><img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original-wordmark.svg" alt="HTML" className="skillimg"/>HTML</div>
                <div className="card-small" data-aos="fade-up" data-aos-delay="400"><img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original-wordmark.svg" alt="CSS" className="skillimg"/>CSS</div>
                <div className="card-small" data-aos="fade-up" data-aos-delay="400"><img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="Javascript" className="skillimg"/>Javascript</div>
                <div className="card-small" data-aos="fade-up" data-aos-delay="400"><img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original-wordmark.svg" alt="React" className="skillimg"/>React</div>
                <div className="card-small" data-aos="fade-up" data-aos-delay="400"><img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg" alt="C++" className="skillimg"/>C++</div>
                <div className="card-small" data-aos="fade-up" data-aos-delay="400"><img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" alt="Python" className="skillimg"/>Python</div>
                <div className="card-small" data-aos="fade-up" data-aos-delay="400"><img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg" alt="Node js" className="skillimg"/>Node</div>
                <div className="card-small" data-aos="fade-up" data-aos-delay="400"><img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original-wordmark.svg" alt="Mongo DB" className="skillimg"/>Mongo DB</div>
            </div>
        </div>
    </div>
  )
}

export default Hero
